module.exports = __webpack_public_path__ + "static/img/4.e4dafd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/4.png
// module id = IUjn
// module chunks = 13